// Source of truth for every teacher-area UI string. Adding a key here breaks type-check in the
// translation files until they catch up, which is the point.
export const en = {
  "language.label": "Language",

  "nav.signOut": "Sign out",
  "nav.breadcrumb": "Breadcrumb",
  "nav.classrooms": "Classrooms",
  "nav.schools": "Schools",
  "nav.sidebar": "Teacher navigation",
  "nav.openMenu": "Open menu",
  "nav.closeMenu": "Close menu",
  "nav.books": "Books",
  "nav.assignHomework": "Assign homework",
  "nav.checkHomework": "Check homework",
  "nav.selfStudyRecord": "Self-study record",

  "common.back": "Back",
  "common.tryAgain": "Try again",
  "common.cancel": "Cancel",
  "common.done": "Done",
  "common.clearAll": "Clear all",
  "common.selectAll": "Select all",
  "common.delete": "Delete",

  "home.welcome": "Welcome, {name}",
  "home.books": "Books",
  "home.books.caption": "Browse every project and lesson you can assign from.",
  "home.classrooms": "Classrooms",
  "home.classrooms.caption": "Your classes and their students.",

  "books.title": "Books",

  "classrooms.title": "Classrooms",
  "classrooms.loadError": "Your classrooms could not be loaded from MyBestUser.",
  "classrooms.studentCount": "{count} students",
  "classrooms.empty": "You are not teaching any classrooms yet.",
  "classroom.fallbackName": "Classroom",

  "check.tabHomework": "Homework",
  "check.column.title": "Homework",
  "check.column.due": "Due",
  "check.column.assigned": "Assigned",
  "check.column.classroom": "Classroom",
  "check.empty": "You have not assigned any homework yet.",
  "check.loadError": "Your assigned homework could not be loaded.",

  "roster.title": "Students",
  "roster.loadError": "This roster could not be loaded.",
  "roster.enrolled": "{count} enrolled",
  "roster.neverSignedIn": "Hasn't signed in yet",
  "roster.empty": "This classroom has no students yet.",

  "student.fallbackName": "Student",
  "student.homework": "Homework",
  "student.homeworkLoadError": "This student's homework could not be loaded.",
  "student.completed": "Completed",
  "student.onTime": "On time",
  "student.overdue": "Overdue",
  "student.report": "Report",
  "student.score": "Self-Study Record",
  "student.reportLoadError": "This student's report could not be loaded.",
  "student.nextFocus": "Next focus",
  "student.streak": "Streak",
  "student.streakDayOne": "{count} day",
  "student.streakDayOther": "{count} days",

  "homework.listLoadError": "This homework could not be loaded.",
  "homework.listEmpty": "Nothing has been assigned to this student yet.",
  "homework.completedOfTotal": "{completed}/{total} completed",
  "homework.submitted": "Submitted",
  "homework.due": "Due",
  "homework.progress": "Progress",
  "homework.reassign": "Reassign",
  "homework.deleteConfirm": 'Delete "{title}"?{warning} This cannot be undone.',
  "homework.deleteWarning": " What they have already done stays in their history.",
  "homework.deleted": "Homework deleted",
  "homework.deleteFailed": "Could not delete homework",
  "homework.fallbackTitle": "Assignment",
  "homework.detailLoadError": "This assignment could not be loaded.",

  "homework.status.done": "Done",
  "homework.status.overdue": "Overdue",
  "homework.status.undone": "Undone",
  "homework.status.late": "Late",

  "review.assigned": "Assigned {date}",
  "review.started": "Started {date}",
  "review.submitted": "Submitted {date}",
  "review.lastPlayed": "Last played {date}",
  "review.dueOn": "Due {date}",
  "review.slidesDone": "{completed}/{total} slides",
  "review.score": "Score",
  "review.slideCount": "{count} slides",
  "review.played": "Played",
  "review.previousSlide": "Previous slide",
  "review.nextSlide": "Next slide",
  "review.slideOfTotal": "Slide {current} of {total}",
  "review.pauseAutoplay": "Pause autoplay",
  "review.playInOrder": "Play slides in order",
  "review.every": "Every",
  "review.seconds": "seconds",
  "review.noSlides": "This assignment no longer has any slides.",
  "review.notPlayed": "This slide hasn't been played for this assignment yet.",
  "review.slideLocation": "Slide location",

  "assign.title": "Assign homework",
  "assign.pickClassroom": "Choose a classroom to assign to.",
  "assign.submit": "Assign",
  "assign.assigned": "Assigned to {count} students",
  "assign.failed": "Could not assign homework",
  "assign.titleLabel": "Title",
  "assign.titlePlaceholder": "Week 3 practice",
  "assign.dueLabel": "Due",
  "assign.slides": "Slides",
  "assign.slideCount": "{count} slides",
  "assign.fromLessonOne": "{count} from {lessons} lesson",
  "assign.fromLessonOther": "{count} from {lessons} lessons",
  "assign.chooseSlides": "Choose slides",
  "assign.noSlides":
    "No slides yet. Open the picker to browse a lesson and see what each slide looks like.",
  "assign.subslideCount": "+{count} subslides",
  "assign.removeSlide": "Remove {name}",
  "assign.students": "Students",
  "assign.selectedCount": "{count} selected",
  "assign.pickStudentsFirst": "Choose students first — which slides you can pick depends on them.",
  "assign.dot.blocked": "Product is not in MBU ticket",
  "assign.dot.absent": "Never logged in",
  "assign.dot.unverified": "MyBestUser was unreachable, so their last sign-in was used",
  "assign.hint.notSignedIn": "Has not signed in yet",
  "assign.hint.checking": "Checking MBU tickets…",
  "assign.hint.notCovered": "Their MBU ticket does not cover {missing}",
  "assign.hint.unverified": "{username} · ticket not verified",

  "library.root": "Library",
  "library.loadError": "This part of the library could not be loaded.",
  "library.itemOne": "{count} item",
  "library.itemOther": "{count} items",
  "library.slideOne": "{count} slide",
  "library.slideOther": "{count} slides",
  "library.empty": "This folder is empty.",
  "library.truncated": "Showing the first {count} of each. Open a folder to narrow it down.",
  "library.reach.noProduct": "Project has no product",
  "library.reach.studentNoProduct": "Student ticket lacks product",
  "library.reach.studentLevelTooLow": "Student level too low",

  "picker.allGroups": "All groups",
  "picker.allTags": "All tags",
  "picker.allTemplates": "All templates",
  "picker.filterByGroup": "Filter by group",
  "picker.filterByTag": "Filter by tag",
  "picker.filterByTemplate": "Filter by template",
  "picker.search": "Search slides",
  "picker.selectVisible": "Select these {count}",
  "picker.deselectVisible": "Deselect these",
  "picker.noMatches": "No slides match these filters.",

  "lesson.fallbackName": "Lesson",
  "lesson.slidesLoadError": "These slides could not be loaded.",
  "lesson.empty": "This lesson has no slides yet.",
  "lesson.slideOne": "{count} slide",
  "lesson.slideOther": "{count} slides",

  "slide.fallbackName": "Slide",
  "slide.notFoundTitle": "Slide not found",
  "slide.notFoundBody": "This slide doesn't exist or was removed.",
  "slide.position": "Slide {current} of {total}",
  "slide.previous": "Previous slide",
  "slide.next": "Next slide",
  "slide.gridItem": "{name}, slide {number}",
  "slide.playsWith": "Plays with this slide",

  "report.performance.title": "Performance",
  "report.performance.band0": "Keep going",
  "report.performance.band1": "Good start",
  "report.performance.band2": "Nice progress",
  "report.performance.band3": "Great work!",
  "report.performance.band4": "On fire!",
  "report.performance.subLow": "Practice more to spark your fire.",
  "report.performance.subMid": "Keep practicing to grow your fire.",
  "report.performance.subHigh": "Your fire is blazing bright!",

  "report.skill.speaking": "Speaking",
  "report.skill.listening": "Listening",
  "report.skill.reading": "Reading",
  "report.skill.grammar": "Grammar",
  "report.skill.writing": "Writing",
  "report.skill.wordRecognition": "Vocabulary",

  "report.insights.title": "Learning insights",
  "report.insights.areaToImprove": "Area to improve",
  "report.insights.strongestSkill": "Strongest skill",
  "report.insights.locked": "Not enough practice to name this yet",

  "report.skills.title": "Skill breakdown",
  "report.skills.locked": "Not enough practice to score yet",
  "report.skills.provisional": "Scored on very little practice so far",
  "report.skills.footnote": "Practice more for higher accuracy",

  "report.duration.minutes": "{count} min",
  "report.duration.hoursMinutes": "{hours}h {minutes}m",
  "report.duration.hours": "{hours}h",

  "report.streak.header": "Streak & progress",
  "report.streak.current": "{count}-day streak",
  "report.streak.none": "No streak",
  "report.streak.noneYet": "No streak yet",
  "report.streak.bestOne": "Best: {count} day",
  "report.streak.bestOther": "Best: {count} days",
  "report.streak.achievement": "{current} of {threshold} days",

  "report.activity.thisMonth": "this month",
  "report.activity.minPerDay": "{count} min/day",
  "report.activity.previousMonth": "Previous month",
  "report.activity.nextMonth": "Next month",
  "report.activity.previousYear": "Previous year",
  "report.activity.nextYear": "Next year",

  "report.day.noPractice": "No practice recorded",
  "report.day.timeUnavailable": "Activity recorded — practice time unavailable",
  "report.day.minutesPracticed": "{count} min practiced",
  "report.day.hoursMinutesPracticed": "{hours}h {minutes}m practiced",
  "report.day.hoursPracticed": "{hours}h practiced",
  "report.day.newVocabulary": "New vocabulary",
  "report.day.noVocabulary": "No new vocabulary this day",
  "report.day.close": "Close day detail",

  "report.weekly.title": "Weekly slides",
  "report.weekly.empty": "No slides this period",
  "report.weekly.previousPeriod": "Previous six weeks",
  "report.weekly.nextPeriod": "Next six weeks",
  "report.weekly.barA11y": "{range}: {count} slides",
  "report.weekly.slideOne": "slide",
  "report.weekly.slideOther": "slides",
  "report.weekly.totalPrefix": "",
  "report.weekly.totalSuffix": " slides practiced all time",

  "report.lessons.title": "Lesson scores",
  "report.lessons.empty": "Nothing here yet",
  "report.lessons.itemCountOne": "{count} item",
  "report.lessons.itemCountOther": "{count} items",
  "report.lessons.lessonCountOne": "{count} lesson",
  "report.lessons.lessonCountOther": "{count} lessons",
  "report.lessons.slidesDone": "{done} of {total} slides done",
  "report.lessons.averageScore": "average {score}",
  "report.lessons.back": "Back",

  "selfStudy.title": "Self-study record",
  "selfStudy.pickClassroom": "Pick a class to see how its students are practising on their own.",
  "selfStudy.classroomCaption": "Open a folder for the class's table, student by lesson.",
  "selfStudy.lessons.title": "Lessons",
  "selfStudy.loadError": "This class's lessons could not be loaded.",
  "selfStudy.noAccount": "Has never signed in",
  "selfStudy.progress.label": "Class records",
  "selfStudy.progress.empty": "This class has no students yet.",
  "selfStudy.progress.loadError": "These records could not be loaded.",
  "selfStudy.table.student": "Student",
  "selfStudy.table.total": "Total",
  "selfStudy.table.open": "Class table",
  "selfStudy.band.strong": "Strong",
  "selfStudy.band.mixed": "Mixed",
  "selfStudy.band.weak": "Weak",
  "selfStudy.band.notStarted": "Not started",

  "readonly.notScored": "Not scored",
  "readonly.correct": "Correct: {answer}",
  "readonly.yourAnswer": "Your answer",
  "readonly.feedback": "Feedback",
  "readonly.playClip": "Play {label}",
  "readonly.stopClip": "Stop {label}",
  "readonly.clipUnavailable": "{label} unavailable",
  "readonly.unsupported": "This slide's details can't be shown.",
  "readonly.myRecording": "my recording",
  "readonly.myRecordingUnavailable": "My recording unavailable",
  "readonly.myReading": "my reading",
  "readonly.myTurn": "my turn",
  "readonly.myAnswer": "My answer",
  "readonly.correctAnswer": "Correct answer",
  "readonly.wordImage": "Word image",
  "readonly.perWord": "Per word",
  "readonly.promptImage": "Prompt image",
  "readonly.promptVideo": "Prompt video",
  "readonly.passageImage": "Passage image",
  "readonly.passageVideo": "Passage video",
  "readonly.passageNotSet": "Passage no longer set",
  "readonly.noParagraphs": "No paragraphs were recorded for this reading.",
  "readonly.paragraph": "Paragraph {number}",
  "readonly.quiz": "Quiz",
  "readonly.theSound": "the sound",
  "readonly.playTheSound": "Play the sound",
  "readonly.stopTheSound": "Stop the sound",
  "readonly.playMySoundRecording": "Play my recording of {phoneme}",
  "readonly.stopMySoundRecording": "Stop my recording of {phoneme}",
  "readonly.options": "Options",
  "readonly.whatYouTyped": "What you typed",
  "readonly.theClip": "the clip",
  "readonly.noCheckpoints": "No checkpoint answers were recorded.",
  "readonly.questionNotSet": "Question no longer set",
  "readonly.answer": "Answer",
  "readonly.conversation": "Conversation",
  "readonly.noTurns": "No turns were recorded for this conversation.",
  "readonly.assessment": "Assessment",
  "readonly.dimension.grammar": "Grammar",
  "readonly.dimension.wordChoice": "Word choice",
  "readonly.dimension.understanding": "Understanding",
  "readonly.dimension.communication": "Communication",
  "readonly.dimension.pronunciation": "Pronunciation",
  "readonly.noCanvasAnswers": "No detailed answers were recorded for this activity.",
  "readonly.noWriting": "No writing was saved for this play.",
  "readonly.wordNumber": "Word {number}",
  "readonly.writingOf": "Writing of {text}",
  "error.accessLocked": "This account is suspended. Please contact an administrator.",
  "error.rateLimited": "Too many requests. Please wait a moment and try again.",
  "error.rateLimitedMinutes": "Too many requests. Please try again in about {minutes} minutes.",
  "readonly.yourWriting": "your writing",
} as const;

export type TranslationKey = keyof typeof en;
